import React from 'react'

const SideProfileIcon = (
  <>
    <path d="M16.25 12.9167H9.75V21.0417H16.25V12.9167Z" fill="#EAC3A2" />
    <path
      d="M13.0001 16.1667C9.71464 16.1667 7.04175 13.4938 7.04175 10.2083V8.04168C7.04175 4.75624 9.71464 2.08334 13.0001 2.08334C16.2855 2.08334 18.9584 4.75624 18.9584 8.04168V10.2083C18.9584 13.4938 16.2855 16.1667 13.0001 16.1667Z"
      fill="#EAD8C5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4269 21.4732L16.25 18.3333H16.2402C15.3359 19.0106 14.2168 19.4167 13 19.4167C11.7833 19.4167 10.6642 19.0106 9.75993 18.3333H9.75004L9.68237 18.3672L2.57491 21.4732C1.75117 21.8332 1.08337 22.8561 1.08337 23.755V25.3734C1.08337 25.6734 1.32703 25.9167 1.62597 25.9167H24.3741C24.6738 25.9167 24.9167 25.6795 24.9167 25.3734V23.755C24.9167 22.8548 24.251 21.8338 23.4269 21.4732Z"
      fill="#9966FB"
    />
  </>
)

export default SideProfileIcon
